import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import deepEqual from 'deep-equal';

import store from '../../store';
import style from '../../../../scss/cvSection.scss';
import {deepClone} from '../../util/deepClone';
import {selectCurrentContentLanguage} from '../../selectors';

@customElement('arc-cv-section')
export class CvSection extends connect(store)(LitElement) {
	static properties = {
		index: {type: Number},
		disabled: {type: Boolean},
		value: {type: Object, hasChanged: (n, o) => !deepEqual(n, o)},
		errors: {type: Array, hasChanged: (n, o) => !deepEqual(n, o)},
	};

	static styles = [style];

	inititalValue = {
		sectionName: [
			{value: '', lang: 'de'},
			{value: '', lang: 'en'},
		],
		entries: [],
	};

	constructor() {
		super();
		this.disabled = false;
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.lang = state.status.lang;
		this.contentLanguage = selectCurrentContentLanguage(state);
	}

	connectedCallback() {
		super.connectedCallback();
		if (!this.value) {
			this.value = deepClone(this.inititalValue);
		}
	}

	handleNameChange(value) {
		this.value.sectionName = value;
		this.dispatchValueChange();
		this.requestUpdate('value');
	}

	handleValueChange(value) {
		this.value.entries = value;
		this.dispatchValueChange();
		this.requestUpdate('value');
	}

	handleRemoveComponent() {
		this.dispatchEvent(
			new CustomEvent('remove-section', {
				detail: {
					index: this.index,
				},
			})
		);
	}

	dispatchValueChange() {
		this.dispatchEvent(
			new CustomEvent('value-change', {
				detail: {
					index: this.index,
					value: this.value,
				},
			})
		);
	}

	render() {
		return html`
			<div class="cvSection">
				<div class="sectionTitle">
					<arc-multilingual-input
						id="sectionName"
						class="formInput"
						.title="${msg('Section Name')}"
						.value=${this.value.sectionName}
						.errors=${this.errors?.params?.sectionName}
						?disabled="${this.disabled}"
						.required=${true}
						.multiline=${false}
						.public=${true}
						@value-change=${(e) => this.handleNameChange(e.detail.value)}
					></arc-multilingual-input>
				</div>
				<arc-form-repeat
					.components=${[
						{
							component: 'arc-cv-entry',
							type: null,
							label: msg('CV Entry'),
							public: true,
						},
					]}
					.data=${this.value.entries}
					.errors=${this.errors?.params?.entries?.params || []}
					?disabled="${this.disabled}"
					@value-change=${(e) => this.handleValueChange(e.detail.value)}
				></arc-form-repeat>
			</div>
		`;
	}
}
